import React from "react";
import { Link } from "react-router-dom";
import Card from "@material-ui/core/Card";
import Loader from "../../common/Loader/Loader";
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography } from "@material-ui/core";
import { APP_ROUTES } from "config/constants";
import settingsIcon from "../../assets/svg/Settings.svg";
import CustomTableFooter from "components/common/CustomTableFooter/CustomTableFooter";

interface UserManagementCardInterface {
  classes: any;
  userDataLoading: any;
  additionalServicesList: any;
  userDialogState: any;
  pageSize: any;
  rowCount: any;
  pageNumber: number;
  fetchNextRecord: any;
}

const UserManagementCard = (props: UserManagementCardInterface) => {
  const { classes, userDataLoading, additionalServicesList, userDialogState, pageSize, rowCount, pageNumber, fetchNextRecord } = props;
  const { isLoading: isUserDialogLoading, userObj } = userDialogState;
  const { userDataRecord } = userObj ?? {};

  const showLoader = userDataLoading || isUserDialogLoading; // NOSONAR

  const shouldRenderTable =
    !showLoader &&
    additionalServicesList &&
    additionalServicesList.length > 0 &&
    userDataRecord &&
    userDataRecord.length > 0;
  const rowsData = shouldRenderTable ? userDataRecord : [];

  const renderTableCell = (title: string) => {
    return (
      <TableCell padding="none" size="small" align="left" className={classes.cellHeaderStyle}>
        <Typography className={classes.cellHeaderSpanStyle}>{`${title}`}</Typography>
      </TableCell>
    );
  };


  const renderTableBodyCell = (data: string | number) => {
    return (
      <TableCell padding="none" size="small" align="left" className={classes.cellDataStyle}>
        <Typography className={classes.cellDataSpanStyle}>{`${data ?? "-"}`}</Typography>
      </TableCell>
    );
  };
  const renderColumnCell = (value: string | number) => <Typography className={classes.cellDataSpanStyle}>{value}</Typography>;
  const renderToolTip = (value: string | number) => <Typography className={classes.toolTipRoot}>{value}</Typography>;

  let content: JSX.Element | null;
  if (showLoader) {
    content = <Card className={classes.cardRoot}><Loader /></Card>;
  } else if (shouldRenderTable) {
    content = (
      <TableContainer className={classes.tableStyle}>
        <Table padding="none" size="small" stickyHeader={true} className={classes.tableRoot}>
          <TableHead className={classes.tableHeaderStyle}>
            <TableRow>
              {renderTableCell(`User ID`)}
              {renderTableCell(`First Name`)}
              {renderTableCell(`Last Name`)}
              {renderTableCell(`Role`)}
              {renderTableCell(`Service Type`)}
              {renderTableCell(`Country`)}
              {renderTableCell(`Status`)}
              {renderTableCell(`Actions`)}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsData.map((row: any, index: number) => (
              <TableRow key={`${row?.id ?? ""}-${index}-rowsData`}>
                {renderTableBodyCell(row?.id ?? "")}
                {renderTableBodyCell(row?.firstName ?? "")}
                {renderTableBodyCell(row?.lastName ?? "")}
                {renderTableBodyCell(row?.userProfile?.role ?? "")}
                <TableCell padding="none" size="small" align="left" className={classes.cellDataStyle}>
                  <Tooltip title={renderToolTip(row?.serviceTypeName ?? "-")} placement="bottom-start">
                    {renderColumnCell(row?.serviceTypeName ?? "-")}
                  </Tooltip>
                </TableCell>
                <TableCell padding="none" size="small" align="left" className={classes.cellDataStyle}>
                  <Tooltip title={renderToolTip(row?.countryDisplayName || "-")} placement="bottom-start">
                    {renderColumnCell(row?.countryDisplayName || "-")}
                  </Tooltip>
                </TableCell>
                <TableCell padding="none" size="small" align="left" className={classes.cellDataStyle}>
                  <Grid container spacing={2} className={classes.statusTypeContainer}>
                    <div className={row?.active ? `${classes.activeStatus} ` : `${classes.inactiveStatus}`}>
                      <div className={`${classes.status}`}>{row?.active ? "ACTIVE" : "INACTIVE"}</div>
                    </div>
                  </Grid>
                </TableCell>
                <TableCell padding="none" size="small" align="left" className={classes.cellDataStyle}>
                  <Link to={{ pathname: `${APP_ROUTES.USER_MANAGEMENT}`, search: `?userDetailId=${row.id}` }}>
                    <div className={classes.editIconStyle}>
                      <img src={settingsIcon} alt="Edit User" />
                    </div>
                  </Link>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {rowsData?.length > 0 && (
          <CustomTableFooter
            rowsData={userDataRecord ?? []}
            classes={classes}
            colSpan={8}
            pageSize={pageSize || 40}
            rowCount={rowCount || 0}
            page={pageNumber}
            fetchNextRecord={fetchNextRecord}
          />
        )}
      </TableContainer>
    );
  } else {
    content = (
      <div className={classes.cardRoot}>
        <p>No user data available.</p>
      </div>
    );
  }

  return content;
};

export default React.memo(UserManagementCard);
